import React from "react";
import {Box, View} from "@unibuddy/patron";
import {ISlideImage} from "./slidesImages";

export const SlidesItem = ({width, image}: {width: number; image: ISlideImage}) => (
    <Box width={width} height="100%" position="relative" overflow="hidden">
        <View
            w="100%"
            h="100%"
            style={{
                backgroundSize: "cover",
                backgroundImage: `url(${image.src})`,
                backgroundPosition: "center",
            }}
        />
    </Box>
);
